import React from "react";
import { SignUpForm } from '../../components/signUpForm/signUpForm';
import style from "./signUp.module.scss";
import Layout from "components/layout/Layout";

export const SignUp = () => {
  return (
    <Layout>
      <div className={style.content}>
        <h3>Sign Up Page</h3>
        <SignUpForm />
      </div>
    </Layout>
  );
};
